/**
 * Application Configuration
 * Loads environment variables from webpack DefinePlugin
 */

/**
 * Get place slug from domain or query parameter
 * Extracts from subdomain (e.g., place-name.kevi.io) or ?place= query param
 * @returns {string} Place slug
 */
function getPlaceSlug() {
  if (process.env.APP_MODE === "development") {
    const placeParam = process.env.PLACE_SLUG;
    return placeParam.replace(/[^-0-9a-z]/g, "");
  }
  
  // Check for ?place= query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const placeParam = urlParams.get("place");
  
  if (placeParam) {
    // Sanitize: only allow lowercase letters, numbers, and hyphens
    return placeParam.replace(/[^-0-9a-z]/g, "");
  }
  
  // Extract from domain (first subdomain)
  const domainParts = window.location.hostname.split(".");
  const slug = domainParts[0];
  
  // Sanitize: only allow lowercase letters, numbers, and hyphens
  return slug.replace(/[^-0-9a-z]/g, "");
}

function hasPreviewFlag() {
  try {
    return new URLSearchParams(window.location.search).has("preview");
  } catch (error) {
    return false;
  }
}

const config = {
  appMode: process.env.APP_MODE || "development",
  apiEndPoint: process.env.API_ENDPOINT || "https://api.kevi.io",
  mixpanelAppId: process.env.MIXPANEL_APP_ID || "",
  googleAnalyticsId: process.env.GOOGLE_ANALYTICS_ID || "",
  isProduction: process.env.APP_MODE === "production",
  isDevelopment: process.env.APP_MODE === "development",
  placeSlug: getPlaceSlug(),
  isPreview: hasPreviewFlag(),
  adminOrigin:
    process.env.ADMIN_ORIGIN ||
    (process.env.APP_MODE === "production" ? "https://adm.kevi.io" : "http://localhost:3000"),
};

export const initConfig = () => {
  window.appMode = config.appMode;
  window.apiEndPoint = config.apiEndPoint;
  window.mixpanelAppId = config.mixpanelAppId;
  window.PLACE_SLUG = config.placeSlug;

  return config;
};

export default config;

